module.exports = __webpack_public_path__ + "static/media/0150_Medium.bcf2acc9.jpg";